import React, { useMemo, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Pagination,
  InputGroup,
  Form
} from 'react-bootstrap';

const LedgerReports = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const [searchQuery, setSearchQuery] = useState('');

  const ledgerEntries = [
    {
      id: 'LDG001',
      date: '2024-11-05',
      time: '10:15 AM',
      txnType: 'Credit',
      description: 'AEPS Commission Credit',
      reference: 'AEPS-20241105-001',
      credit: 1500.0,
      debit: 0,
      balance: 48250.0,
      channel: 'AEPS',
      status: 'Settled',
      counterparty: '24Pay Settlement'
    },
    {
      id: 'LDG002',
      date: '2024-11-05',
      time: '09:45 AM',
      txnType: 'Debit',
      description: 'Wallet Top-up to Distributor',
      reference: 'WAL-20241105-014',
      credit: 0,
      debit: 2000.0,
      balance: 46750.0,
      channel: 'Wallet Transfer',
      status: 'Settled',
      counterparty: 'ABC Distributor'
    },
    {
      id: 'LDG003',
      date: '2024-11-04',
      time: '06:35 PM',
      txnType: 'Credit',
      description: 'Recharge Commission',
      reference: 'RCG-20241104-112',
      credit: 320.0,
      debit: 0,
      balance: 48750.0,
      channel: 'Recharge',
      status: 'Settled',
      counterparty: 'Recharge API'
    },
    {
      id: 'LDG004',
      date: '2024-11-04',
      time: '04:10 PM',
      txnType: 'Debit',
      description: 'Claim Refund Processing Fee',
      reference: 'CLM-20241104-021',
      credit: 0,
      debit: 150.0,
      balance: 48430.0,
      channel: 'Claim Refund',
      status: 'Pending',
      counterparty: 'System Charges'
    },
    {
      id: 'LDG005',
      date: '2024-11-04',
      time: '01:25 PM',
      txnType: 'Debit',
      description: 'Fund Transfer to Bank',
      reference: 'FTB-20241104-089',
      credit: 0,
      debit: 5000.0,
      balance: 48580.0,
      channel: 'Fund Transfer',
      status: 'Settled',
      counterparty: 'HDFC Bank - ****5123'
    },
    {
      id: 'LDG006',
      date: '2024-11-03',
      time: '11:50 AM',
      txnType: 'Credit',
      description: 'Bill Payment Incentive',
      reference: 'BILL-20241103-056',
      credit: 220.0,
      debit: 0,
      balance: 53580.0,
      channel: 'Bill Pay',
      status: 'Settled',
      counterparty: 'Utility Board'
    },
    {
      id: 'LDG007',
      date: '2024-11-03',
      time: '09:40 AM',
      txnType: 'Debit',
      description: 'UPI Withdrawal',
      reference: 'UPI-20241103-222',
      credit: 0,
      debit: 1200.0,
      balance: 53360.0,
      channel: 'UPI Transfer',
      status: 'Settled',
      counterparty: 'UPI VPA - xyz@upi'
    },
    {
      id: 'LDG008',
      date: '2024-11-02',
      time: '05:55 PM',
      txnType: 'Credit',
      description: 'Settlement Adjustment',
      reference: 'STL-20241102-018',
      credit: 980.0,
      debit: 0,
      balance: 54560.0,
      channel: 'Settlement',
      status: 'Settled',
      counterparty: 'Admin Adjustment'
    },
    {
      id: 'LDG009',
      date: '2024-11-02',
      time: '03:05 PM',
      txnType: 'Debit',
      description: 'Device Purchase EMI',
      reference: 'DEV-20241102-004',
      credit: 0,
      debit: 900.0,
      balance: 53580.0,
      channel: 'Device Order',
      status: 'Settled',
      counterparty: 'POS Device EMI'
    },
    {
      id: 'LDG010',
      date: '2024-11-02',
      time: '12:20 PM',
      txnType: 'Credit',
      description: 'Distributor Incentive Share',
      reference: 'INC-20241102-076',
      credit: 650.0,
      debit: 0,
      balance: 54480.0,
      channel: 'Commission',
      status: 'Settled',
      counterparty: 'ABC Distributor'
    },
    {
      id: 'LDG011',
      date: '2024-11-01',
      time: '04:45 PM',
      txnType: 'Credit',
      description: 'Network Payment Cash-back',
      reference: 'NET-20241101-033',
      credit: 180.0,
      debit: 0,
      balance: 53830.0,
      channel: 'Network Payment',
      status: 'Settled',
      counterparty: 'Network Operator'
    },
    {
      id: 'LDG012',
      date: '2024-11-01',
      time: '02:15 PM',
      txnType: 'Debit',
      description: 'Retailer Wallet Adjustment',
      reference: 'ADJ-20241101-019',
      credit: 0,
      debit: 500.0,
      balance: 53650.0,
      channel: 'Adjustment',
      status: 'Settled',
      counterparty: 'System Adjustment'
    },
    {
      id: 'LDG013',
      date: '2024-11-01',
      time: '11:05 AM',
      txnType: 'Credit',
      description: 'Retailer Top-up',
      reference: 'TOP-20241101-051',
      credit: 5000.0,
      debit: 0,
      balance: 54150.0,
      channel: 'Wallet Top-up',
      status: 'Settled',
      counterparty: 'Self'
    },
    {
      id: 'LDG014',
      date: '2024-10-31',
      time: '06:30 PM',
      txnType: 'Debit',
      description: 'Support Plan Subscription',
      reference: 'SUB-20241031-007',
      credit: 0,
      debit: 699.0,
      balance: 49150.0,
      channel: 'Subscription',
      status: 'Settled',
      counterparty: 'Support Plan'
    },
    {
      id: 'LDG015',
      date: '2024-10-31',
      time: '02:50 PM',
      txnType: 'Credit',
      description: 'DTH Commission Share',
      reference: 'DTH-20241031-118',
      credit: 275.0,
      debit: 0,
      balance: 49849.0,
      channel: 'DTH',
      status: 'Settled',
      counterparty: 'DTH Provider'
    }
  ];

  const filteredEntries = useMemo(() => {
    if (!searchQuery) {
      return ledgerEntries;
    }

    return ledgerEntries.filter((entry) =>
      Object.values(entry).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [ledgerEntries, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentEntries = filteredEntries.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredEntries.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => (value ? `₹${value.toFixed(2)}` : '-');

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="ledger-reports-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Ledger
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {[
                        'ID',
                        'Ledger_Date',
                        'Ledger_Time',
                        'Txn_Type',
                        'Description',
                        'Ledger_Reference_ID',
                        'Credit',
                        'Debit',
                        'Balance',
                        'Channel',
                        'Status',
                        'Counterparty'
                      ].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentEntries.length > 0 ? (
                      currentEntries.map((entry) => (
                        <tr key={entry.id} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{entry.id}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.date}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.time}</td>
                          <td style={{ padding: '12px 16px', color: entry.txnType === 'Credit' ? '#198754' : '#dc3545', fontSize: '13px', fontWeight: 600 }}>
                            {entry.txnType}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', maxWidth: '220px' }}>
                            <details>
                              <summary style={{ cursor: 'pointer', fontWeight: 500 }}>
                                View
                              </summary>
                            </details>
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', fontFamily: 'monospace' }}>{entry.reference}</td>
                          <td style={{ padding: '12px 16px', color: '#198754', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(entry.credit)}</td>
                          <td style={{ padding: '12px 16px', color: '#dc3545', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(entry.debit)}</td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>{formatCurrency(entry.balance)}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.channel}</td>
                          <td style={{ padding: '12px 16px', color: entry.status === 'Settled' ? '#198754' : '#fd7e14', fontSize: '13px' }}>{entry.status}</td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>{entry.counterparty}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={12} className="text-center py-4" style={{ color: '#999' }}>
                          No ledger entries found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredEntries.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredEntries.length)} of {filteredEntries.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .ledger-reports-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default LedgerReports;


